import { Text } from "components/common/Text";
import { FC, memo, useLayoutEffect, useRef } from "react";
import Gauge from "svg-gauge";

type ChartProps = {
  homeValue: number;
  awayValue: number;
  title: string;
  valueFormatter?: (value: number) => string | number;
};

export const Chart: FC<ChartProps> = memo(
  ({ homeValue, title, awayValue, valueFormatter }) => {
    const gaugeContainer = useRef<HTMLDivElement>(null);
    const gaugeRef = useRef<any>(null);
    const total = homeValue + awayValue;
    const awayPercentage = total > 0 ? (awayValue / total) * 100 : 0;

    const formatValue = (value: number) =>
      valueFormatter ? valueFormatter(value) : value;

    useLayoutEffect(() => {
      if (gaugeContainer.current) {
        if (!gaugeRef.current) {
          gaugeRef.current = Gauge(gaugeContainer.current, {
            max: 100,
            dialStartAngle: -90,
            dialEndAngle: -90.001,
            showValue: false,
          });
          gaugeRef.current.setValue(awayPercentage);
        } else {
          gaugeRef.current.setValueAnimated(awayPercentage);
        }
      }
    }, [awayPercentage]);

    return (
      <div
        className="flex min-w-[20vw] flex-col items-center justify-center"
        style={
          {
            "--rotation-value":
              -((awayPercentage / 100) * 360 - 180) / 2 + "deg",
          } as React.CSSProperties
        }
      >
        <Text
          variant="chartTitle"
          className="mb-[1vw] w-full text-center font-bold text-statisticTitle"
        >
          {title}
        </Text>
        <div className="flex items-center justify-center gap-[1vw]">
          <span className="mx-[1vw] text-white">
            <Text className="value" variant="chartValue">
              {formatValue(homeValue)}
            </Text>
          </span>
          <div
            ref={gaugeContainer}
            className="gauge-container mx-auto w-[10vw]"
          />
          <span className="mx-[1vw] text-white">
            <Text variant="chartValue">{formatValue(awayValue)}</Text>
          </span>
        </div>
      </div>
    );
  }
);
